/**
 * Whether a set of held permission keys grants `required`. Same three tiers as the backend's
 * `Role::hasPermission`: the global `*`, an entity wildcard (`merchant.*`) or an exact key.
 */
export function grants(held: readonly string[], required: string): boolean {
  if (held.includes('*') || held.includes(required)) return true

  const entity = required.split('.')[0]

  return entity !== undefined && held.includes(`${entity}.*`)
}
